"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileMoveOverlay = exports.getDestination = exports.copyOrMove = exports.handleItems = exports.getHeaderText = exports.getStatusText = void 0;
exports.isFolder = isFolder;
exports.getLabel = getLabel;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var FolderTree_1 = require("components/FolderTree");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var FilesActions = require("@caddigital/sok-reducers/lib/actions/files");
var CartActions = require("@caddigital/sok-reducers/lib/actions/cart");
var FolderPermissionsActions = require("@caddigital/sok-reducers/lib/actions/folders/permissionChecks");
var Types = require("types");
var Tree_1 = require("@caddigital/sok-reducers/lib/modules/files/tree/Tree");
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
require("./styles.scss");
var extractReturnType = Types.extractReturnType;
function isFolder(x) {
    return x.type === 'FOLDER';
}
function getLabel(mode) {
    if (mode === 'COPY_FROM_SELECTION_CART' || mode === 'COPY') {
        return (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/titleCopy');
    }
    else if (mode === 'MOVE_FROM_SELECTION_CART' || mode === 'MOVE') {
        return (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/titleMove');
    }
    else {
        return '';
    }
}
var getStatusText = function (mode, success, failure) {
    if ((mode === 'COPY_FROM_SELECTION_CART' || mode === 'COPY') &&
        success &&
        !failure) {
        return (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/statusCopied');
    }
    else if ((mode === 'MOVE_FROM_SELECTION_CART' || mode === 'MOVE') &&
        success &&
        !failure) {
        return (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/statusMoved');
    }
    else if ((mode === 'MOVE_FROM_SELECTION_CART' || mode === 'MOVE') &&
        !success) {
        return (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/statusMove');
    }
    else {
        return (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/statusCopy');
    }
};
exports.getStatusText = getStatusText;
var getHeaderText = function (mode) {
    if (mode === 'COPY_FROM_SELECTION_CART' || mode === 'COPY') {
        return (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/statusCopy');
    }
    else {
        return (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/statusMove');
    }
};
exports.getHeaderText = getHeaderText;
function saveButtonDisabled(props) {
    if (!props.copyOrMove.target) {
        return true;
    }
    return false;
}
var mapStateToProps = function (state) {
    return {
        currentProject: state.project.currentProject.status === 'FETCHED'
            ? state.project.currentProject.project
            : undefined,
        copyOrMove: state.files.copyOrMove,
        selectedItems: state.files.selectedItems,
        currentFolder: state.files.currentFolder,
        selectCartItems: state.cart.data.items,
        permissionChecks: state.files.permissionChecks,
        user: state.auth.current.user
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    closeOverlay: function () {
        dispatch(FolderPermissionsActions.resetChecks());
        dispatch(FilesActions.refreshFiles());
        dispatch(FilesActions.FolderTreeActions.copyFilesReset());
        dispatch(FilesActions.FolderTreeActions.copyFilesToggleOverlay(Types.Reducer.CLOSED));
    },
    changeExpand: function (expand, folder) {
        return dispatch(FilesActions.FolderTreeActions.copyChangeExpand(expand, folder));
    },
    selectItem: function (folder, value) {
        dispatch(FilesActions.FolderTreeActions.copySelectTargetAction(folder));
    },
    getContent: function (parent) {
        return dispatch(FilesActions.FolderTreeActions.fetchTree(parent, ['FOLDER'], 'MINIMAL'));
    },
    copyFiles: function (files, ignored, destination, revisionDuplicates) {
        dispatch(FilesActions.FolderTreeActions.copyFilesRequestAction('COPY', files, destination, ignored, undefined, revisionDuplicates));
    },
    moveFiles: function (files, ignored, destination, revisionDuplicates) {
        dispatch(FilesActions.FolderTreeActions.copyFilesRequestAction('MOVE', files, destination, ignored, undefined, revisionDuplicates));
    },
    userToggleCopyOrMoveResult: function () {
        dispatch(FilesActions.FolderTreeActions.userToggleCopyOrMoveResult());
    },
    clearCart: function (currentProjectId) {
        dispatch(CartActions.clearAll(currentProjectId));
    }
}); };
var statePropsExtractable = extractReturnType(mapStateToProps);
var dispatchPropsExtractable = extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('CopyOrMove'), (0, recompose_1.withState)('revisionDuplicates', 'setRevisionDuplicates', false), (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentWillReceiveProps: function (nextProps) {
        if (this.props.copyOrMove.mode === 'CLOSED' &&
            nextProps.copyOrMove.mode !== 'CLOSED' &&
            nextProps.rootFolder !== undefined) {
            nextProps.getContent(nextProps.rootFolder);
            this.props.setRevisionDuplicates(nextProps.copyOrMove.mode === 'MOVE' ? true : false);
        }
    }
}), recompose_1.pure);
var handleItems = function (item) {
    if (item.type === 'FOLDER')
        return item.id;
    else
        return item.id;
};
exports.handleItems = handleItems;
var copyOrMove = function (props) { return function () {
    if (!props.copyOrMove.target) {
        return;
    }
    switch (props.copyOrMove.mode) {
        case 'COPY':
            return props.copyFiles(props.selectedItems.map(function (x) { return new Tree_1.Node(x); }), [], props.copyOrMove.target.getValue(), props.revisionDuplicates);
        case 'MOVE':
            return props.moveFiles(props.selectedItems.map(function (x) { return new Tree_1.Node(x); }), [], props.copyOrMove.target.getValue(), props.revisionDuplicates);
        case 'MOVE_FROM_SELECTION_CART':
            return props.moveFiles(props.selectCartItems.map(function (x) { return new Tree_1.Node(x); }), [], props.copyOrMove.target.getValue(), true);
        case 'COPY_FROM_SELECTION_CART':
            return props.copyFiles(props.selectCartItems.map(function (x) { return new Tree_1.Node(x); }), [], props.copyOrMove.target.getValue(), true);
    }
    props.setRevisionDuplicates(false);
}; };
exports.copyOrMove = copyOrMove;
var getDestination = function (target) {
    if (!target) {
        return '';
    }
    return target.getValue().name;
};
exports.getDestination = getDestination;
function getLockedMessage(props) {
    if (props.permissionChecks.moveReasons.findIndex(function (reason) { return reason.code === 423; }) > -1) {
        return (React.createElement("div", { className: 'content-locked' },
            React.createElement("div", { className: "lock-icon" },
                React.createElement(Icon_1.Icon, { className: "icofont-barricade" })),
            (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/lockedSession')));
    }
    return undefined;
}
var isGranoOrProjectAdmin = function (project) {
    var perm = project.perm ? project.perm & ~acl.FEATURE_MASK : 0x00;
    return !!(perm & acl.PROJECT_ADMIN_GRANT);
};
var getSelectedQuantity = function (selectedItems, selectedCartItems) {
    var _a;
    return (selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length) > 0
        ? selectedItems.length
        : ((_a = selectedCartItems === null || selectedCartItems === void 0 ? void 0 : selectedCartItems.length) !== null && _a !== void 0 ? _a : 0);
};
exports.FileMoveOverlay = enhance(function (props) { return (React.createElement(sok_ui_1.Overlay, { isOpen: props.copyOrMove.mode !== Types.Reducer.CLOSED, onClose: function () { return props.closeOverlay(); } },
    React.createElement(sok_ui_1.SideMenu, { className: 'sok-file-move-details', isOpen: props.copyOrMove.mode !== Types.Reducer.CLOSED, docked: false, orientation: 'right' },
        React.createElement(sok_ui_1.Header, { onClose: function () { return props.closeOverlay(); } }, (0, exports.getHeaderText)(props.copyOrMove.mode)),
        React.createElement(sok_ui_1.Container, { className: props.copyOrMove.status !== 'STANDBY' ||
                (props.copyOrMove.data.status === 'FETCHING' &&
                    !props.copyOrMove.data.tree)
                ? 'centered'
                : null },
            props.copyOrMove.data.status === 'FETCHING' && (React.createElement("div", { className: 'loading-spinner' },
                React.createElement(sok_ui_1.LoadingSpinner, null))),
            (props.permissionChecks.checkCopyStatus === 'FAILED' ||
                props.permissionChecks.checkMoveStatus === 'FAILED') && (React.createElement("div", { className: 'missing-permissions' },
                React.createElement("div", { className: "warning-icon" },
                    React.createElement(Icon_1.Icon, { className: "fa-exclamation-triangle", prefix: 'fal' })),
                (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/checkingPermissionsError'))),
            props.permissionChecks.checkCopyStatus === 'CHECKED' &&
                props.permissionChecks.copyReasons.findIndex(function (reason) { return reason.code === 403; }) > -1 && (React.createElement("div", { className: 'missing-permissions' },
                React.createElement("div", { className: "warning-icon" },
                    React.createElement(Icon_1.Icon, { className: "fa-exclamation-triangle", prefix: 'fal' })),
                (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/missingCopyPermissions'))),
            props.permissionChecks.checkMoveStatus === 'CHECKED' &&
                props.permissionChecks.moveReasons.findIndex(function (reason) { return reason.code === 403; }) > -1 && (React.createElement("div", { className: 'missing-permissions' },
                React.createElement("div", { className: "warning-icon" },
                    React.createElement(Icon_1.Icon, { className: "fa-exclamation-triangle", prefix: 'fal' })),
                (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/missingMovePermissions'))),
            props.permissionChecks.checkMoveStatus === 'CHECKED' &&
                getLockedMessage(props),
            props.copyOrMove.status !== 'STANDBY' && (React.createElement("div", { className: "loading-spinner" },
                React.createElement(sok_ui_1.RequestSpinner, { isLoading: props.copyOrMove.status === 'COPYING', success: props.copyOrMove.status === 'SUCCESS' }))),
            (props.copyOrMove.status === 'SUCCESS' ||
                props.copyOrMove.status === 'FAILURE') && (React.createElement("div", { className: 'result-information' },
                React.createElement("div", { className: 'result-text' },
                    (0, exports.getStatusText)(props.copyOrMove.mode, props.copyOrMove.status === 'SUCCESS', props.copyOrMove.status === 'FAILURE'),
                    ' ',
                    getSelectedQuantity(props.selectedItems, props.selectCartItems),
                    ' ',
                    (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/itemsTo'),
                    ' ',
                    (0, exports.getDestination)(props.copyOrMove.target)),
                React.createElement(sok_ui_1.Button, { style: { marginRight: '20px' }, color: props.copyOrMove.status === 'SUCCESS' ? 'base-green' : 'red', className: 'ok-button', onClick: function () {
                        if (props.copyOrMove.status === 'SUCCESS') {
                            return props.closeOverlay();
                        }
                        if (props.currentFolder !== null && props.currentFolder) {
                            props.getContent(props.currentFolder);
                            props.userToggleCopyOrMoveResult();
                        }
                    }, text: props.copyOrMove.status === 'SUCCESS'
                        ? "".concat((0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/submitOk'))
                        : "".concat((0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/submitFailed')) }))),
            props.copyOrMove.data.tree !== null &&
                props.copyOrMove.status === 'STANDBY' &&
                props.rootFolder && (React.createElement(FolderTree_1.default, { showRoot: true, perm: props.currentProject ? props.currentProject.perm : 0x00, parentIdentifier: props.rootFolder.uuid, tree: props.copyOrMove.data.tree, selectItem: function (file, value) {
                    props.selectItem(file, value);
                }, changeExpand: props.changeExpand, getContent: function (folder) {
                    props.getContent(folder);
                } }))),
        props.copyOrMove.status === 'STANDBY' &&
            (props.copyOrMove.mode === 'COPY' ||
                props.copyOrMove.mode === 'MOVE') && (React.createElement("div", { className: "revisionDuplicates-container" },
            React.createElement(sok_ui_1.Input, { type: "checkbox", name: "revisionDuplicates", label: (0, translation_1.getLocalization)('components/FileCopyOrMove/confirmRevisionDuplicateFiles'), elementClassName: 'revisionDuplicates', value: props.revisionDuplicates, onClick: function (e) {
                    return props.setRevisionDuplicates(e.target.checked);
                } }))),
        React.createElement(sok_ui_1.Footer, null,
            props.copyOrMove.status === 'STANDBY' ||
                props.copyOrMove.status === 'FAILURE' ? (React.createElement(sok_ui_1.Button, { color: 'base-green', disabled: saveButtonDisabled(props), onClick: (0, exports.copyOrMove)(props), text: (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/save') })) : (React.createElement(sok_ui_1.Button, { color: 'blue', onClick: function () {
                    props.userToggleCopyOrMoveResult();
                }, disabled: props.copyOrMove.status === 'COPYING', text: (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/continue') })),
            React.createElement(sok_ui_1.Button, { color: 'dark-gray', onClick: function () { return props.closeOverlay(); }, disabled: props.copyOrMove.status === 'COPYING', text: (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/cancel') }))))); });
